import {trans} from '@frontend/helpers'
import type {
    ChatDetailsData,
    ChatMessageData,
} from '@frontend/modules/private/chats/ChatsModuleTypes'
import {ChatMessageForm} from '@frontend/modules/private/chats/components/ChatMessageForm'
import {CardFooter} from 'swayok-react-mdb-ui-kit/components/Card/CardFooter'
import {HtmlContent} from 'swayok-react-mdb-ui-kit/components/Typography/HtmlContent'

interface Props {
    chat: ChatDetailsData
    disabled?: boolean
    canSendImages: boolean
    onNewMessageAdded: (message: ChatMessageData) => void
    readNotViewedMessages: () => void
}

// Нижняя часть карточки просмотра чата (форма добавления комментария).
export function ChatDetailsCardFooter(props: Props) {

    const {
        chat,
        disabled,
        canSendImages,
        onNewMessageAdded,
        readNotViewedMessages,
    } = props

    return (
        <CardFooter className="flex-shrink-0 border-top px-0 pt-3 pb-3 mx-3 mx-sm-4">
            {!chat.otherUserHasDeletedChat && (
                <ChatMessageForm
                    chatId={chat.id}
                    adId={chat.ad?.id}
                    executorId={chat.executor?.id}
                    disabled={disabled}
                    canSendImages={canSendImages}
                    onNewMessageAdded={onNewMessageAdded}
                    onFocus={readNotViewedMessages}
                />
            )}
            {chat.otherUserHasDeletedChat && (
                <div className="text-center py-2 text-red">
                    <HtmlContent
                        html={trans().cabinet.chats.other_user_has_deleted_chat(
                            chat.otherUser.name
                        )}
                    />
                </div>
            )}
        </CardFooter>
    )
}
